import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-upload-step-images',
    templateUrl: './upload-step-images.component.html',
    styleUrls: ['./upload-step-images.component.scss']
})
export class UploadStepImagesComponent {

    @Input() images: string[] = [];

    @Output() imagesChange = new EventEmitter<string[]>();

    uploading = false;

    public config: DropzoneConfigInterface = {
        clickable: true,
        maxFiles: 1,
        autoReset: 1000,
        errorReset: 1000,
        cancelReset: 1000,
        acceptedFiles: '.pdf,.doc,.docx,.xls,.xlsx,image/*'
    };

    constructor(
        private storage: AngularFireStorage
    ) { }

    async onUploadInfo(e) {

        try {

            this.uploading = true;

            const fileName = e[0].name;
            const base64url = e[1].files.file;

            const extension = fileName.split('.').pop();

            const uniqueName =
                new Date().getTime() +
                Math.random().toString(36).substring(2);

            const refUrl =
                `/processSteps/${uniqueName}.${extension}`;

            const contentType =
                base64url.split(";")[0].slice(5);

            const fileRef = this.storage.ref(refUrl);

            const task = this.storage
                .ref("/processSteps/")
                .child(`${uniqueName}.${extension}`)
                .putString(base64url, "data_url", {
                    contentType
                });

            task.snapshotChanges()
                .pipe(
                    finalize(async () => {

                        const downloadURL =
                            await fileRef.getDownloadURL().toPromise();

                        this.images.push(downloadURL);

                        this.imagesChange.emit(this.images);

                        this.uploading = false;

                    })
                )
                .subscribe();

        } catch (error) {

            this.uploading = false;

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No fue posible subir la imagen.'
            });

        }

    }

    removeImage(index: number) {

        this.images.splice(index, 1);

        this.imagesChange.emit(this.images);

    }

    preview(fileUrl: string) {
        const urlLower = fileUrl.toLowerCase();
        
        if (urlLower.includes('.pdf')) {
            window.open(fileUrl, '_blank');
        } 
        // Si es Word o Excel, usamos el visor de Office en una pestaña nueva
        else if (urlLower.includes('.doc') || urlLower.includes('.xls')) {
            const officeViewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`;
            window.open(officeViewerUrl, '_blank');
        } 
        else {
            // Imágenes
            Swal.fire({
                imageUrl: fileUrl,
                imageAlt: 'Captura',
                width: '90%',
                showConfirmButton: false,
                showCloseButton: true
            });
        }
    }

}